<template>
  <div
    class="wfs_container"
    :class="{
      collapsed,
    }"
  >
    <div class="header_section">
      <div v-if="!collapsed" class="status_name" v-text="status.name" />
      <div class="action">
        <template v-if="!collapsed">
          <BaseButton
            v-if="folders.count > 0"
            color="primary"
            type="primary"
            class="mr-2"
            @click="openRelanchMass"
          >
            {{ $t("folder.relaunch") }}
          </BaseButton>
          <div class="collapse_btn folder_number" v-text="folders.count" />
        </template>
        <v-btn class="collapse_btn" small icon @click="toggleCollapsed()">
          <v-icon> $mdiChevronLeft </v-icon>
        </v-btn>
      </div>
    </div>
    <div class="body_section">
      <div v-if="collapsed" class="header_section">
        <div class="action">
          <div class="folder_number" v-text="folders.count" />
        </div>
        <div class="status_name" v-text="status.name" />
      </div>
      <template v-else>
        <template v-if="folders.items.length">
          <router-link
            v-for="(folder, index) in folders.items"
            :key="`wfi-${index}`"
            class="folder_item"
            tag="div"
            :to="{
              name: 'folderDetail',
              params: {
                organizationId: $route.params.organizationId,
                folderId: folder.id,
              },
            }"
          >
            <div class="folder_name" v-text="folder.name" />
            <div
              v-if="folder.contact"
              class="contact"
              v-text="folder.contact.email"
            />
            <div
              v-if="folder.collaborator"
              class="collaborator"
              v-text="folder.collaborator.email"
            />
          </router-link>
          <div v-intersect="loadMoreFolders" class="intersection" />
        </template>
        <div v-if="fetchingFolders">
          <div v-for="value in 4" :key="value" class="folder_skeleton">
            <v-skeleton-loader class="skeleton" type="text" />
          </div>
        </div>
        <div
          v-if="!fetchingFolders && !folders.items.length"
          class="no_folder"
          v-text="$t('utils.no_folder_for_status')"
        />
      </template>
    </div>
  </div>
</template>
<script>
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";
export default {
  name: "WorkflowFolderStatus",
  props: {
    status: {
      type: Object,
      required: true,
    },
    wfStatuses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      collapsed: false,
      fetchingFolders: true,
      folders: {
        count: 0,
        next: 0,
        previous: 0,
        items: [],
      },
      filters: {
        page_size: 10,
        page: 1,
      },
    };
  },
  created() {
    this.fetchFolders();
  },
  methods: {
    async fetchFolders() {
      this.fetchingFolders = true;
      try {
        const res = await WorkflowAPI.getWorkflowFolder({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          params: {
            page: this.filters.page,
            status: this.status.id,
            page_size: this.filters.page_size,
          },
        });
        this.folders = {
          ...res.data,
          items: [...this.folders.items, ...res.data.results],
        };
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.fetchingFolders = false;
    },
    async loadMoreFolders(_, __, isIntersecting) {
      if (!isIntersecting || this.fetchingFolders || !this.folders.next) return;
      this.filters.page = this.folders.next;
      this.fetchFolders();
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    openRelanchMass() {
      this.$emit("openRelanchMass", this.status);
    },
  },
};
</script>

<style lang="scss" scoped>
.wfs_container {
  width: 350px;
  border: 0.5px solid #ecebf1;
  border-radius: 4px;
  flex: none;
  overflow: hidden;
  .header_section {
    background: #e6eff4;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 4px;
    transition: all 0.3s ease-in;
    .status_name {
      flex: 1;
      padding: 0 12px;
      font-size: 18px;
      line-height: 20px;
      text-transform: capitalize;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.25s ease-in-out;
    }
    .action {
      display: flex;
      align-items: center;
      .collapse_btn {
        transition: all 0.3s ease-in;
      }
      .folder_number {
        height: 20px;
        padding: 4px;
        margin: 4px;
        font-size: 11px;
        list-style: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #2536cc;
        border-radius: 5px;
      }
    }
  }
  .body_section {
    padding: 12px;
    width: 100%;
    height: calc(100% - 40px);
    overflow: hidden;
    overflow-y: auto;
    background: #fff;
    position: relative;
    .header_section {
      width: 350px;
      top: 160px;
      left: 50%;
      position: absolute;
      transform-origin: center center;
      transform: translate(-50%, 0) rotate(90deg);
      background: #fff;
      transition: none;
    }
    .folder_item {
      border: 4px;
      padding: 12px;
      margin-bottom: 16px;
      background: #f4f7ff;
      cursor: pointer;
      .folder_name {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
      }
      .contact {
        font-size: 13px;
        line-height: 18px;
      }
      .collaborator {
        font-size: 10px;
        list-style: 10px;
        text-align: right;
        color: #4f4f4f;
      }
    }
    .folder_skeleton {
      width: 100%;
      margin-bottom: 16px;
      height: 85px;
    }
    .intersection {
      height: 10px;
    }
    .skeleton {
      height: 100%;
      width: 100%;
      ::v-deep {
        .v-skeleton-loader__bone {
          height: 100%;
        }
      }
    }
    .no_folder {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      color: #bdbdbd;
      text-align: center;
    }
  }
  &.collapsed {
    width: 40px;
    flex: none;
    .header_section {
      padding: 0px;
      align-items: center;
      justify-content: center;
      .action {
        margin: 0;
        .collapse_btn {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
